import { AxiosResponse } from "axios";

import { IAddBaseline, IPatientBaseline } from "../@types/Baselines";
import { api } from "./api";

export const baselinesService = {
  async addBaseline(request: IAddBaseline): Promise<AxiosResponse> {
    const url = "/Portal/PatientBaselines";

    const serverResponse = await api.post(url, request);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async archiveBaseline(
    patientId: number,
    measurementType: string,
    isISHLTBaseline: boolean
  ): Promise<AxiosResponse> {
    const url = "/Portal/PatientBaselines/ArchivePatientBaseline";

    const serverResponse = await api.post(url, {
      patientId,
      measurementType,
      isISHLTBaseline,
    });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async checkForNewISHLTBaselines(
    patientId: number,
    measurementType: string
  ): Promise<AxiosResponse<IPatientBaseline>> {
    const url = "/Portal/Baselines/ISHLT/CheckNew";

    const serverResponse = await api.post(url, {
      patientId,
      measurementType,
    });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async markISHLTBaselineAsSeen(
    patientId: number,
    baselineId: string,
    measurementType: string
  ): Promise<AxiosResponse> {
    const url = "/Portal/Baselines/ISHLT/MarkAsSeen";

    const serverResponse = await api.post(url, {
      patientId,
      baselineId,
      measurementType,
    });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async updateISHLTBaselineEnabledStatus(
    patientId: number,
    measurementType: string
  ): Promise<AxiosResponse> {
    const url = "/Portal/Baselines/ISHLT/UpdateEnabledStatus";

    const serverResponse = await api.post(url, {
      patientId,
      measurementType,
    });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },
};
